import { api, ApiError } from "../api.js";
import { h, fmtDate, eraLabel } from "../ui.js";
import type { App } from "../main.js";

export function accountView(app: App): HTMLElement {
  const a = app.me.account!;
  const sessionsBox = h("ul", { class: "list" }, h("li", { class: "dim" }, "Loading…"));
  void api.sessions().then(({ sessions }) =>
    sessionsBox.replaceChildren(...sessions.map((s) =>
      h("li", {},
        h("span", { class: "grow" }, s.device || "unknown device", s.current ? h("span", { class: "badge green", style: "margin-left:8px" }, "this device") : null),
        h("span", { class: "dim mono-num" }, fmtDate(s.lastSeen)),
        s.current ? null : h("button", { class: "btn", onclick: async () => { await api.revoke(s.id); app.go("/account"); } }, "Sign out"),
      ))));
  const renameInput = h("input", { class: "input", type: "text", maxlength: "16", placeholder: "new handle" });
  const renameMsg = h("div");
  const p = app.me.profile;
  return h("div", { class: "stack" },
    h("div", { class: "panel" },
      h("h1", {}, "Account"),
      h("dl", { class: "kv" },
        h("dt", {}, "Email"), h("dd", {}, a.email),
        h("dt", {}, "Since"), h("dd", { class: "mono-num" }, fmtDate(a.createdAt)),
        h("dt", {}, "Era"), h("dd", {}, h("span", { class: "badge" }, eraLabel(app.me.era?.id ?? ""))),
        h("dt", {}, "Character"), h("dd", {}, p ? p.handle : h("a", { href: "/create" }, "Create one")),
      ),
      h("button", { class: "btn", onclick: async () => { await api.logout(); app.go("/"); } }, "Sign out"),
    ),
    p ? h("div", { class: "panel" },
      h("h2", {}, "Rename character"),
      h("p", { class: "dim" }, p.renamed ? "You've used your free rename for this era." : "One free rename per era."),
      p.renamed ? null : h("form", { onsubmit: async (e: Event) => { e.preventDefault(); try { await api.rename(renameInput.value.trim()); app.go("/account"); } catch (err) { renameMsg.replaceChildren(h("div", { class: "msg error" }, err instanceof ApiError ? err.message : "error")); } } },
        h("div", { class: "row" }, h("div", { class: "grow" }, renameInput), h("button", { class: "btn", type: "submit" }, "Rename")), renameMsg),
    ) : null,
    h("div", { class: "panel" },
      h("h2", {}, "Era history"),
      h("ul", { class: "list" }, ...(app.me.history ?? []).map((hp) =>
        h("li", {}, h("span", { class: "badge", style: "margin-right:8px" }, eraLabel(hp.era_id)), h("span", { class: "grow" }, hp.handle), h("span", { class: "dim mono-num" }, hp.archived_at ? `archived ${fmtDate(hp.archived_at)}` : "active")))),
    ),
    h("div", { class: "panel" }, h("h2", {}, "Signed-in devices"), sessionsBox),
  );
}
